import { DISCOUNT_MASTER_DETAILS } from "../../types/DiscountMasterType";
import axios from "axios";

const getDiscountMasterDetailsAction = (data) => {
	return {
		type: DISCOUNT_MASTER_DETAILS,
		payload: data,
	};
};

export const loadSingleDiscountMaster = (id) => {
	return async (dispatch) => {
		try {
			const { data } = await axios.get(`discount-master/${id}`);
			dispatch(getDiscountMasterDetailsAction(data));
		} catch (error) {
			console.log(error.message);
		}
	};
};
